import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, input, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointObserverService } from '@core';

@Component({
    selector: 'lib-expandable-panel',
    imports: [CommonModule, MatExpansionModule, MatIconModule],
    templateUrl: './expandable-panel.component.html',
    styleUrl: './expandable-panel.component.scss'
})
export class ExpandablePanelComponent implements AfterViewInit {
  defaultExpanded = input<boolean | undefined>();
  title = input<string>();
  description = input<string>();

  expanded = signal<boolean>(true);

  readonly isMobile = inject(BreakpointObserverService).isMobile;

  toggle() {
    this.expanded.set(!this.expanded());
  }
  ngAfterViewInit(): void {
    this.expanded.set(this.defaultExpanded() === undefined ? !this.isMobile() : this.expanded() || false);
  }
}
